"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSlideGesture = void 0;
const react_1 = __importDefault(require("react"));
const react_use_gesture_1 = require("react-use-gesture");
function useSlideGesture({ enabled, sliderWidth, dragThreshold, onDrag, onDragThresholdExceeded }) {
    const startMovement = react_1.default.useRef(0);
    return (0, react_use_gesture_1.useGesture)({
        onDragStart: () => {
            startMovement.current = 0;
        },
        onDrag: ({ down, movement: [xMovement] }) => {
            if (!enabled) {
                return;
            }
            const dragMovement = startMovement.current - xMovement;
            onDrag(down ? dragMovement / sliderWidth : 0);
            if (down && Math.abs(dragMovement) > dragThreshold) {
                if (onDragThresholdExceeded(dragMovement < 0 ? 'right' : 'left')) {
                    startMovement.current = xMovement;
                }
            }
        }
    });
}
exports.useSlideGesture = useSlideGesture;
